import slugify from 'slugify';

export const slugifyLocationName = (name: string) => {
    return name && slugify(
        name, 
        {
            replacement: '-',  // replace spaces with replacement characte
            lower: true,      // convert to lower case
        }
    );
}